import { render, staticRenderFns } from "./AnnexUpload.vue?vue&type=template&id=4cec75ba&"
import script from "./AnnexUpload.vue?vue&type=script&lang=js&"
export * from "./AnnexUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports